import chartConfigBar from './chartConfigBar.json'
import chartConfigLine from './chartConfigLine.json'
import chartConfigArea from './chartConfigArea.json'
import chartConfigColumn from './chartConfigColumn.json'

export enum E_ANALYSIS_CHART {
    PATENT_TRENDS_BAR = 'patent_trends_bar',
    PAPER_TRENDS_LINE = 'paper_trends_line',
    TECH_CURRENT_AREA = 'tech_current_area',
    TECH_CURRENT_COLUMN = 'tech_current_column',
    MAIN_PLAYER_COLUMN = 'main_player_column'
}

export interface IResultChart {
    img?: any,
    chartType: E_ANALYSIS_CHART,
    titleKey: string,
    descKey: string,
    config: any,
}

export const resultChartsTechObjectives: IResultChart[] = [{
    // img: chart2.id,
    chartType: E_ANALYSIS_CHART.PATENT_TRENDS_BAR,
    titleKey: `analysis.charts.${E_ANALYSIS_CHART.PATENT_TRENDS_BAR}.title`,
    descKey: `analysis.charts.${E_ANALYSIS_CHART.PATENT_TRENDS_BAR}.desc`,
    config: chartConfigBar,
}, {
    // img: chart1.id,
    chartType: E_ANALYSIS_CHART.PAPER_TRENDS_LINE,
    titleKey: `analysis.charts.${E_ANALYSIS_CHART.PAPER_TRENDS_LINE}.title`,
    descKey: `analysis.charts.${E_ANALYSIS_CHART.PAPER_TRENDS_LINE}.desc`,
    config: chartConfigLine,
}];

export const resultChartsTechCurrent: IResultChart[] = [{
    // img: chart2.id,
    chartType: E_ANALYSIS_CHART.TECH_CURRENT_AREA,
    titleKey: `analysis.charts.${E_ANALYSIS_CHART.TECH_CURRENT_AREA}.title`,
    descKey: `analysis.charts.${E_ANALYSIS_CHART.TECH_CURRENT_AREA}.desc`,
    config: chartConfigArea,
}, {
    // img: chart1.id,
    chartType: E_ANALYSIS_CHART.TECH_CURRENT_COLUMN,
    titleKey: `analysis.charts.${E_ANALYSIS_CHART.TECH_CURRENT_COLUMN}.title`,
    descKey: `analysis.charts.${E_ANALYSIS_CHART.TECH_CURRENT_COLUMN}.desc`,
    config: chartConfigColumn,
}];
